import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const MotorSportsIcon = observer('MotorSportsIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <mask
                id='motorSportsMask'
                width='14'
                height='11'
                x='1'
                y='3'
                maskUnits='userSpaceOnUse'
                style={{ maskType: 'alpha' }}
            >
                <path
                    fill='#142448'
                    d='M9.6 13.517H1.55a.2.2 0 0 1-.15-.067.2.2 0 0 1-.067-.15q0-.783.025-1.375t.075-1.058h5.234q1.15 0 1.958-.817t.808-2q0-.85-.475-1.542a2.83 2.83 0 0 0-1.275-1.025L5.45 4.6A8.07 8.07 0 0 1 9.4 3.583q2.133 0 3.65 1.442t1.517 3.525-1.442 3.525T9.6 13.517M1.65 9.55a8.57 8.57 0 0 1 2.533-4.067l3 1.217q.434.183.684.55.25.366.25.8 0 .633-.425 1.067a1.42 1.42 0 0 1-1.059.433z'
                />
            </mask>
            <g mask='url(#motorSportsMask)'>
                <path
                    fill='#0b1627'
                    fillOpacity='.64'
                    d='M0 0h16v16H0z'
                />
            </g>
        </SvgElement>
    );
});
